import axios from "axios";
import tokenManager from "../utils/tokenManager";
// import { useKeycloak } from '@react-keycloak/web';

// const { keycloak } = useKeycloak();

const $host = axios.create({
    // baseURL: "http://127.0.0.1:6500"
    // baseURL: "http://192.168.0.177:6500"
    baseURL: "https://s.komoks.ru"

})

const $geocodeHost = axios.create({
    // baseURL: "http://127.0.0.1:5500"
    // baseURL: "https://nominatim.openstreetmap.org"
    // baseURL: "http://192.168.88.104:8080"
    baseURL: "https://s.komoks.ru"
    // baseURL: "https://maps.komoks.ru"
    // baseURL: process.env.REACT_APP_API_URL

})

const $authHost = axios.create({
    // baseURL: "http://127.0.0.1:6500",
    // baseURL: "http://192.168.0.170:6500"
    baseURL: "https://s.komoks.ru"
    // withCredentials: true
})

// Интерцептор для автоматического добавления токена в заголовки запросов
const authInterceptor = config => {
    try {
        const token = tokenManager.getCurrentToken();
        if (token) {
            config.headers.authorization = `Bearer ${token}`;
        }
    } catch (error) {
        console.error('❌ Ошибка в интерцепторе запроса:', error);
    }
    return config;
}

// Интерцептор для обработки ответов и автоматического обновления токена при ошибке 401
const responseInterceptor = {
    success: (response) => response,
    error: async (error) => {
        const originalRequest = error.config;
        
        // Если получили 401 ошибку и это не повторный запрос
        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            
            try {
                console.log('🔄 Получена 401 ошибка, пытаемся обновить токен...');
                const auth = tokenManager.getAuthContext();
                
                if (auth && auth.isAuthenticated) {
                    const refreshed = await tokenManager.refreshToken(auth);
                    if (refreshed) {
                        // Обновляем токен в заголовке и повторяем запрос
                        const newToken = tokenManager.getCurrentToken();
                        if (newToken) {
                            originalRequest.headers.authorization = `Bearer ${newToken}`;
                            console.log('✅ Токен обновлен, повторяем запрос');
                            return $authHost(originalRequest);
                        }
                    }
                } else {
                    console.log('❌ Пользователь не авторизован или контекст недоступен');
                }
            } catch (refreshError) {
                console.error('❌ Ошибка при обновлении токена:', refreshError);
            }
        }
        
        // Возвращаем ошибку в любом случае
        return Promise.reject(error);
    }
};

// Применяем интерцепторы к $authHost
$authHost.interceptors.request.use(authInterceptor);
$authHost.interceptors.response.use(responseInterceptor.success, responseInterceptor.error);

// const authInterceptor = config => {
//     config.headers.authorization = `Bearer ${localStorage.getItem('token')}`
//     // console.log(config)
//     return config
// }

// $authHost.interceptors.request.use(authInterceptor)

// API функции для работы с файлами
export const fileApi = {
    // Загрузить файл в S3
    uploadFile: async (file, options = {}) => {
        const formData = new FormData();
        formData.append('file', file);
        
        // Добавляем опциональные параметры
        if (options.bucket) formData.append('bucket', options.bucket);
        if (options.key) formData.append('key', options.key);
        if (options.type) formData.append('type', options.type);
        if (options.metadata) formData.append('metadata', JSON.stringify(options.metadata));
        if (options.user_id) formData.append('user_id', options.user_id);
        if (options.match_id) formData.append('match_id', options.match_id);

        const response = await $authHost.post('/apig/s3/files', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        
        return response.data;
    },

    // Получить файл по ID
    getFileById: async (fileId) => {
        const response = await $authHost.get(`/apig/s3/files/${fileId}`);
        return response.data;
    },

    // Получить информацию о файле по ID
    getFileInfoById: async (fileId) => {
        const response = await $authHost.get(`/apig/s3/files/${fileId}/info`);
        return response.data;
    },

    // Получить превью файла по ID
    getFilePreview: async (fileId) => {
        const response = await $authHost.get(`/apig/s3/files/${fileId}/preview`);
        return response.data;
    },

    // Удалить файл по ID
    deleteFile: async (fileId) => {
        const response = await $authHost.delete(`/apig/s3/files/${fileId}`);
        return response.data;
    },

    // Получить список файлов
    getFilesList: async (options = {}) => {
        const params = new URLSearchParams();
        Object.keys(options).forEach(key => {
            if (options[key] !== undefined && options[key] !== null) {
                params.append(key, options[key]);
            }
        });
        
        const response = await $authHost.get(`/apig/s3/files?${params.toString()}`);
        return response.data;
    }
};

export {
    $host,
    $authHost,
    $geocodeHost
}